import { NavItem, Select } from '@billy/design-system'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useAutomaticPaymentRemindersModalForm } from '../../contexts/automaticPaymentRemindersModalFormContext'
import * as Styled from './styles'
import { getAfterDueDateSelectItems } from './utils/getAfterDueDateSelectItems'

export const AutomaticPaymentRemindersRepeatTypeSelect = () => {
  const { t } = useTranslation()
  const { automaticPaymentRemindersModalForm } = useAutomaticPaymentRemindersModalForm()
  const { FormItem } = automaticPaymentRemindersModalForm

  const afterDueDateSelectItems: NavItem[] = useMemo(() => getAfterDueDateSelectItems(t), [t])

  return (
    <Styled.RepeatTypeSelectWrapper>
      <FormItem
        itemColumnStart={1}
        itemColumnEnd={3}
        name="repeat"
        render={({ field: { onChange, value, ...rest } }) => (
          <Select
            dropdownSize="fitTrigger"
            items={afterDueDateSelectItems}
            onSelect={onChange}
            selectedId={value}
            {...rest}
          />
        )}
      />
    </Styled.RepeatTypeSelectWrapper>
  )
}
